(() => {
	function init() {
		AOS.init();
	}

	// Events
	// ----------------------------------------

	$WINDOW.on('load', () => {
		init();
	});
})();
